// import dayjs from "dayjs";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";

export function DatePicker({
	onChange,
	onHide = () => {},
	children,
	singleDatePicker = false,
	initialSettings = {startDate: new Date(), showDropdowns: true},
}) {
	const handleChange = (event, picker) => {
		if (singleDatePicker) {
			const display = picker?.startDate?.format("MM/DD/YYYY") || event.target.value;
			const value = picker?.startDate?.format("YYYY-MM-DD") || display;
			// Ensure input shows the selected value even if autoUpdateInput is false
			if (display) event.target.value = display;
			onChange(value);
		} else {
			const startDisplay = picker?.startDate?.format("MM/DD/YYYY");
			const endDisplay = picker?.endDate?.format("MM/DD/YYYY");
			const startDate = picker?.startDate?.format("YYYY-MM-DD");
			const endDate = picker?.endDate?.format("YYYY-MM-DD");

			if (startDisplay && endDisplay) {
				event.target.value = `${startDisplay} - ${endDisplay}`;
			}

			onChange({startDate, endDate});
		}
	};

	const handleHide = (event, picker) => {
		if (singleDatePicker) {
			const display = picker?.startDate?.format("MM/DD/YYYY") || event.target.value;
			const value = picker?.startDate?.format("YYYY-MM-DD") || display;
			onHide(value);
		} else {
			const startDate = picker?.startDate?.format("YYYY-MM-DD");
			const endDate = picker?.endDate?.format("YYYY-MM-DD");
			onHide({startDate, endDate});
		}
	};

	return (
		<DateRangePicker
			initialSettings={{...initialSettings, singleDatePicker}}
			onApply={handleChange}
			onHide={handleHide}>
			{children}
		</DateRangePicker>
	);
}
